var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"af-google-drive-picker",on:{"click":_vm.handleButtonClick}},[_vm._v(" "+_vm._s(_vm.$t('resume.googledrive_title'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }